import React from 'react';
import { useOverlayContext } from '~/contexts';
import InviteOrEditMemberModal from '../InviteOrEditMemberModal';
export function useInviteMemberModal() {
    const overlayContext = useOverlayContext();
    const openInviteMemberModal = ()=>overlayContext.showModal({
            content: (param)=>{
                let { dismissModal } = param;
                return React.createElement(InviteOrEditMemberModal, {
                    onClose: dismissModal
                });
            }
        });
    return {
        openInviteMemberModal
    };
}
